export const services = [
  {
    icon: "ri-restaurant-line",
    title: "Streat Food Festival",
    description:
      "Organisation complète de festivals gastronomiques urbains, mettant en valeur la diversité culinaire et l'art de la rue.",
  },
  {
    icon: "ri-gift-line",
    title: "Marchés de Noël",
    description:
      "Conception, organisation et coordination de marchés de Noël alliant ambiance féérique, efficacité et performance.",
  },
  {
    icon: "ri-calendar-event-line",
    title: "Événements",
    description:
      "Conception sur mesure d'événements professionnels et privés reflétant votre identité et vos valeurs.",
  },
];

export const portfolioItems = [
  {
    image:
      "https://static.readdy.ai/image/254cde0d10dfb5832a5e0a0044c661fc/aeaaee3df70c294a7574482799ab3b99.jpeg",
    title: "Le Village de Noël Vevey",
    alt: "Le Village de Noël Vevey",
  },
  {
    image:
      "https://static.readdy.ai/image/254cde0d10dfb5832a5e0a0044c661fc/ee3aa2cfc55f0d71353611867225e12a.jpeg",
    title: "Beach food festival Vevey",
    alt: "Street Food Festival Vevey",
  },
  {
    image:
      "https://static.readdy.ai/image/254cde0d10dfb5832a5e0a0044c661fc/949ad8517d517fa23e4fcba495e772e2.png",
    title: "Vevey Riviera Noel",
    alt: "Vevey Riviera Noel",
  },
];

export const stats = [
  {
    value: 25000,
    suffix: "+",
    label: "Visiteurs accueillis sur nos plus grands événements",
  },
  {
    value: 1800,
    suffix: "",
    label: "m² pour notre plus grand site",
  },
  {
    value: 40,
    suffix: "",
    label: "Jours d'exploitation consécutifs sur notre plus long événement",
  },
  {
    value: 35,
    suffix: "+",
    label: "Collaborateurs sous notre supervision",
  },
];

export const partners = [
  {
    image:
      "https://static.readdy.ai/image/254cde0d10dfb5832a5e0a0044c661fc/6a028f378ea604c193c5d57c0e60ee9f.png",
    alt: "Le Village de Noël",
    href: "https://www.veveynoel.ch",
  },
  {
    image:
      "https://static.readdy.ai/image/254cde0d10dfb5832a5e0a0044c661fc/4ae18bc6d5e1e703cc018748216286a7.png",
    alt: "Beach Food Festival Vevey",
    href: "https://www.vevey-streatfoodfest.ch/",
  },
  {
    image:
      "https://static.readdy.ai/image/254cde0d10dfb5832a5e0a0044c661fc/f3c952564382b6614fd5d59f5ac80850.png",
    alt: "Riviera Vevey Noel",
    href: "https://www.veveyrivieranoel.com/",
  },
  {
    image:
      "https://static.readdy.ai/image/254cde0d10dfb5832a5e0a0044c661fc/1ea0ec3929088d86dd1f83fdd44859fd.png",
    alt: "Vevey",
    href: "https://www.vevey.ch",
  },
  {
    image:
      "https://static.readdy.ai/image/254cde0d10dfb5832a5e0a0044c661fc/417ca432d40d43b3c84c375906b828d3.png",
    alt: "Légurivera",
    href: "https://www.leguriviera-groupe.ch/",
  },
  {
    image:
      "https://static.readdy.ai/image/254cde0d10dfb5832a5e0a0044c661fc/b218e13c4715b1246d08d091b6eace9b.png",
    alt: "Socialife",
    href: "https://socialife.ch/",
    darkBg: true,
  },
  {
    image:
      "https://storage.readdy-site.link/project_files/2f83d064-4368-49c5-aa2e-85e52f732183/3b9d9b7e-6754-42c0-a238-656585cfd56c_paradise.png",
    alt: "Paradise",
    href: "#",
    darkBg: true,
  },
];

export const approachItems = [
  "Une conception sur mesure, pensée en fonction de vos besoins réels",
  "Une gestion rigoureuse de la logistique, des équipes et des prestataires",
  "Un réseau fiable de partenaires, sélectionnés pour leur sérieux et leur savoir-faire",
  "Un accompagnement humain et réactif, du premier échange jusqu'au démontage final",
];

export const plugAndBarFeatures = [
  "Jusqu'à 1'000 bières servies par heure",
  "Grande capacité de stockage et service rapide",
  "Solution clé en main, prête à l'emploi",
];

export const navLinks = [
  { label: "Accueil", href: "#accueil" },
  { label: "Services", href: "#services" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Contact", href: "#contact" },
];